<template>
  <div class="container-fluid mt-5">
    <div>
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col-8">
            <h3 class="mb-0">Movimiento de Caja</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <span class="ml-3">Nuevo Movimiento: &nbsp;</span>
            <input
              v-model="radio.status"
              type="radio"
              id="uno"
              value="true"
              class="mb-2 mr-1 ml-6"
              name="motivo"
            />
            <label for="uno" class="mr-2">Ingreso</label>
            <input
              v-model="radio.status"
              type="radio"
              id="dos"
              value="false"
              class="mb-2 mr-1 ml-3"
              name="motivo"
            />
            <label for="dos" class="mr-2">Egreso</label>
          </div>
          <br>
          <v-money-spinner v-model="movimiento.cantidad" v-bind="config"></v-money-spinner>
          <div class="mt-3 mb-3">
          <el-select
            v-if="radio.status == 'true'"
            class="select-primary pagination-select"
            v-model="movimiento.motivo_ingreso"
            placeholder="Motivo Ingreso"
            v-bind:value = "movimiento.motivo_ingreso"
          >
            <el-option
              class="select-primary"
              v-for="ingreso in ingresos"
              :key="ingreso.id"
              :value="ingreso"
            >
            </el-option>
          </el-select>

          <el-select
            class="select-primary pagination-select"
            v-model="movimiento.motivo_egreso"
            placeholder="Motivo Egreso"
            v-if="radio.status == 'false'"
            v-bind:value = "movimiento.motivo_egreso"
          >
            <el-option
              class="select-primary"
              v-for="egreso in egresos"
              :key="egreso.id"
              :value="egreso"
            >
            </el-option>
          </el-select>
          </div>
          
          <base-input v-model="movimiento.detalles" placeholder="Detalles"> </base-input>
          <div class="my-4 mt-3">
            <base-button
              type="button"
              class="btn btn-default hover-apolo"
              native-type="submit"
              @click="registraMovimiento()"          
            >
              Registrar Movimiento
            </base-button>
          </div> 
        </div>
      </card>
    </div>
     <modal :show.sync="showPayIngresoModal" modal-classes="modal-primary" size="sm">
      <h6 slot="header" class="mt-0 modal-title">Registro de ingreso</h6>
      <form v-if="showPayIngresoModal" class="new-event--form mt-3">
        <div class="row">
          <span class="col-12">Total a ingresar: ${{ movimiento.cantidad }}</span>
          <span class="col-12">Métodos de pago</span>
          <base-checkbox class="col-9 ml-3" v-model="movimiento.efectivo" :disabled="movimiento.pago_tarjeta">
            Efectivo
          </base-checkbox>
          <span class="col-12 text-right">Cantidad restante a pagar MXN <strong>${{calculateRestanteMovimiento}}</strong></span>
          <span class="col-8 text-right">Se paga con MXN</span>
          <ValidationProvider class="col-4 text-right" name="Cantidad MXN" rules="integer:0,100000" v-slot="{ errors }">
            <base-input
              :disabled="movimiento.pago_tarjeta"
              placeholder="Cantidad"
              v-model="movimiento.efectivo_mxn"
            />
            <validation-error :errors="errors" />
          </ValidationProvider>
          <!--
          <span class="col-8 text-right">Se paga con USD</span>
          <ValidationProvider class="col-4 text-right" name="cantidad USD" rules="integer:0,100000" v-slot="{ errors }">
            <base-input
              placeholder="Cantidad"
              v-model="movimiento.efectivo_usd"
            />
            <validation-error :errors="errors" />
          </ValidationProvider>
          <span class="col-12 text-right">Tipo de cambio: ${{tasa_usd_mxn}} En pesos: ${{tasa_usd_mxn * movimiento.efectivo_usd}}</span>
          -->
          <span class="col-12 text-right">Cambio: ${{calculateCambioMovimiento}}</span>

          <base-checkbox class="col-9 ml-3" v-model="movimiento.pago_tarjeta" :disabled="movimiento.efectivo">
            Tarjeta
          </base-checkbox>
          <pulse-loader class="text-center col-12" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
          <div v-else class="col-12">
            <p v-if="mensaje_pago_tarjeta != null" class="col-12" style="color: green !important; margin-left: -15px !important;">{{ mensaje_pago_tarjeta }}</p>
            <p v-if="mensaje_error_pago_tarjeta != null" class="col-12" style="color: red !important; margin-left: -15px !important;">{{ mensaje_error_pago_tarjeta }}</p>
            <div style="margin-top: -20px !important;">
              <ValidationProvider class="col-12" name="cantidad a pagar con tarjeta" rules="integer:1,100000" v-slot="{ errors }">
                <base-input v-if="movimiento.pago_tarjeta"
                  disabled
                  placeholder="Cantidad a pagar"
                  v-model="movimiento.tarjeta"
                />
                <validation-error :errors="errors" />
              </ValidationProvider>
            </div>
            <div style="margin-top: -20px !important;">
              <base-input v-if="movimiento.pago_tarjeta"
                disabled
                placeholder="Folio tarjeta"
                v-model="movimiento.folio_tarjeta"
              />
              <validation-error :errors="apiValidationErrors.folio_tarjeta" />
            </div>
          </div>
          <!---
          <base-checkbox class="col-9 ml-3" v-model="movimiento.pago_deposito">
            Depósito a cuenta
          </base-checkbox>
          <ValidationProvider class="col-12" name="cantidad a pagar con deposito" rules="integer:1,100000" v-slot="{ errors }">
            <base-input v-if="movimiento.pago_deposito"
              placeholder="Cantidad a pagar"
              v-model="movimiento.deposito"
            />
            <validation-error :errors="errors" />
          </ValidationProvider>
          <ValidationProvider class="col-12" name="folio de pago con deposito" rules="numeric" v-slot="{ errors }">
            <base-input v-if="movimiento.pago_deposito"
              placeholder="Folio deposito"
              v-model="movimiento.folio_deposito"
            />
            <validation-error :errors="errors" />
          </ValidationProvider>
          <validation-error class="col-12" :errors="apiValidationErrors.folio_deposito" />
          -->
          <validation-error class="col-12" :errors="apiValidationErrors.monto" />
          <validation-error class="col-12" :errors="apiValidationErrors.efectivo_mxn" />
          <span class="col-12 text-right"><strong>Acumulado de pagos: ${{calculateAcumuladoMovimiento}}</strong></span>
        </div>
        <input type="hidden" class="new-event--start"/>
        <input type="hidden" class="new-event--end"/>
      </form>
      <template slot="footer">
        <button v-if="finalizar" type="submit" class="btn btn-default hover-apolo new-event--add" @click="reload()">Finalizar</button>
        <div v-else>
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="pay()">Pagar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" :disabled="disabledCancelPay" @click="showPayIngresoModal = false, mensaje_error_pago_tarjeta = null">Cancelar</button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from 'vue';
import MoneySpinner from 'v-money-spinner'
Vue.use(MoneySpinner)
import {Impresora} from "@/printer/Impresora.js";
import ImpresionMovimiento from "./ImpresionMovimiento.vue";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es/es";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import "sweetalert2/dist/sweetalert2.css";
import formMixin from "@/mixins/form-mixin";
import axios from "axios";
import swal from "sweetalert2";
import ValidationError from "@/components/ValidationError.vue";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { ValidationProvider, ValidationObserver,
         extend } from 'vee-validate';

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    ValidationProvider,
    ValidationError,
    PulseLoader
  },

  mixins: [formMixin],

  data() {
    return {
      ingresos: [],
      egresos: [],
      movimiento: {
        type:"Ingreso | Egreso",
        agencia_id: null,
        ingreso: null,
        egreso: null,
        cantidad: null,
        motivo: null,
        motivo_ingreso: null,
        motivo_egreso: null,
        detalles: null,
        monto: null,
        efectivo: true,
        efectivo_mxn: null,
        efectivo_usd: null,
        tasa_usd_mxn: null,
        efectivo_usd_mxn: null,
        tarjeta: null,
        folio_tarjeta: null,
        deposito: null,
        folio_deposito: null
      },
      radio: {
        status: null,
      },
      movimiento_ingreso: null,
      movimiento_egreso: null,
      tasa_usd_mxn: null,
      showPayIngresoModal: false,
      config: {
        spinner: true,
        step: 1,
        min: 0,
        max: 1000000,
        prefix: "$",
        precision: 2,
        decimal: '.',
        thousands: ',',
        bootstrap: true,
        amend: false,
        masked: true
      },
      loadingSpinner: false,
      color: '#0068a0',
      size: '30px',
      mensaje_pago_tarjeta: null,
      mensaje_error_pago_tarjeta: null,
      disabledCancelPay: false,
      finalizar: false
    };
  },

  mounted() {
    this.getMotivoIngreso() 
    this.getMotivoEgreso()
    this.getOpciones()
  },

  computed: {
    calculateCambioMovimiento: function(){
      var result = 0.00;
      if(this.calculateRestanteMovimiento === 0){
        var result = this.movimiento.cantidad.replace('$', "").replace(',', "");
        if(this.movimiento.efectivo_mxn){
          result = result - Number(this.movimiento.efectivo_mxn);
        }
        if(this.movimiento.efectivo_usd){
          result = result - Number(this.tasa_usd_mxn * this.movimiento.efectivo_usd);
        }
        if(this.movimiento.pago_tarjeta){
          result = result - Number(this.movimiento.tarjeta);
        }
        if(this.movimiento.pago_deposito){
          result = result - Number(this.movimiento.deposito);
        }
        if(result < 0){
          result = Math.abs(result);
        }
        return result;
      }
      return Number(result).toFixed(2);
    },
    calculateAcumuladoMovimiento: function(){
      var result = 0.0;
      if(this.movimiento.efectivo_mxn){
        result = result + Number(this.movimiento.efectivo_mxn);
      }
      if(this.movimiento.efectivo_usd){
        var usd = this.tasa_usd_mxn * this.movimiento.efectivo_usd;
        result = result + Number(usd);
      }
      if(this.movimiento.tarjeta){
        result = result + Number(this.movimiento.tarjeta);
      }
      if(this.movimiento.deposito){
        result = result + Number(this.movimiento.deposito);
      }
      return Number(result).toFixed(2);
    },
    calculateTotalPagoMovimiento: function(){
        var result=0.0;
        if(this.movimiento.cantidad != null){
          result = Number(this.movimiento.cantidad.replace('$', "").replace(',', ""));
        }
        return result;
    },
    calculateRestanteMovimiento: function(){
      var result = this.calculateTotalPagoMovimiento;
      if(this.movimiento.efectivo_mxn){
        result = (result - Number(this.movimiento.efectivo_mxn));
      }
      if(this.movimiento.efectivo_usd){
        result = result - Number((this.tasa_usd_mxn * this.movimiento.efectivo_usd));
      }
      if(this.movimiento.tarjeta){
        result = result - Number(this.movimiento.tarjeta);
      }
      if(this.movimiento.deposito){
        result = result - Number(this.movimiento.deposito);
      }
      if(result < 0){
        result = 0;
      }
      return Number(result).toFixed(2);
    },
  },
  
  watch: {
    'movimiento.pago_tarjeta': {
      handler: "changeMetodoPago",
      immediate: false,
    },
    'movimiento.efectivo': {
      handler: "changeMetodoPago",
      immediate: false,
    }
  },

  methods: {
    changeMetodoPago(){
      if(this.movimiento.efectivo === false){
        this.movimiento.efectivo_mxn = null;
        this.movimiento.efectivo_usd = null;
        this.movimiento.efectivo_usd_mxn = null;
      }
      if(this.movimiento.pago_tarjeta === false){
        this.movimiento.tarjeta = null;
        this.movimiento.folio_tarjeta = null;
        this.mensaje_error_pago_tarjeta = null;
      }
      else if(this.disabledCancelPay === false){
        this.movimiento.tarjeta = 0;
        this.movimiento.tarjeta = this.calculateRestanteMovimiento;
      }
    },
    commify(n){
      var parts = n.toString().split(".");
      const numberPart = parts[0];
      const decimalPart = parts[1];
      const thousands = /\B(?=(\d{3})+(?!\d))/g;
      return '$'+numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");
    },

    async getOpciones(){
      await this.$store.dispatch("opciones/list");
      const opciones = await { ...this.$store.getters["opciones/list"] };
      this.tasa_usd_mxn = opciones.data[5].attributes.valor;
      let me = await this.$store.getters["profile/me"];
      if(me.attributes.agencia_activa != 'sin agencia'){
        this.movimiento.agencia = me.relationships.agencias.data.find(item => item.attributes.nombre == me.attributes.agencia_activa);
        this.movimiento.agencia_id = this.movimiento.agencia.id;
      }
    },
    
    async getMotivoIngreso() {
      const url = process.env.VUE_APP_API_BASE_URL;
      let config = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };
      axios.get(`${url}/movimientos_caja/motivosIngreso`, config)
        .then((response) => {
          this.ingresos = response.data;
        }).catch((error) => {
          console.log(error);
        });
    },

    async getMotivoEgreso() {
      const url = process.env.VUE_APP_API_BASE_URL;
      let config = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };
      axios.get(`${url}/movimientos_caja/motivosEgreso`, config)
        .then((response) => {
          this.egresos = response.data;
        }).catch((error) => {
          console.log(error);
        });
    },
    pay(){
      if(this.movimiento.tarjeta != null && this.movimiento.tarjeta != ''){
        this.payTarjeta();
      }else{
        this.payMovimiento();
      }
    },

    async payTarjeta(){
      this.loadingSpinner = true;
      //Nombre cajero y motivo
      let me = await this.$store.getters["profile/me"];
      let username = (me.attributes.username).substr(0, 6);
      let motivo = (this.movimiento.motivo_ingreso).substr(0,27);
      
      let pinpad = new Impresora;
      //Fecha y hora
      let fecha = pinpad.parseDate(new Date());
      //Referencia
      let referencia = 'MC-'+this.changeSimbol(motivo)+'-'+fecha;

      pinpad.autorizarPago(this.movimiento.tarjeta, username, referencia).then(respuesta => {
        if(respuesta.status === true){
          this.mensaje_error_pago_tarjeta = null;
          this.movimiento.folio_tarjeta = respuesta.autorizacion;
          this.mensaje_pago_tarjeta = respuesta.mensaje;
          this.disabledCancelPay = true;
          this.loadingSpinner = false;
          this.payMovimiento();
        }else{
          this.movimiento.tarjeta = null;
          this.mensaje_error_pago_tarjeta = respuesta.mensaje+': '+respuesta.detalle;
          this.movimiento.tarjeta = null;
          this.loadingSpinner = false;
        }
      });
    },

    async payMovimiento(){
      if(this.movimiento.motivo_ingreso != null){
        this.movimiento.motivo = this.movimiento.motivo_ingreso;
      }
      this.movimiento.monto = this.calculateTotalPagoMovimiento;
      this.movimiento.total_metodos = this.calculateAcumuladoMovimiento;
      this.movimiento.cambio = this.calculateCambioMovimiento;
      this.movimiento.saldo_efectivo_mxn = this.movimiento.efectivo_mxn - this.calculateCambioMovimiento;
      this.movimiento.tasa_usd_mxn = this.tasa_usd_mxn;
      this.movimiento.efectivo_usd_mxn = (this.movimiento.tasa_usd_mxn * this.movimiento.efectivo_usd);
      if(this.movimiento.efectivo_usd_mxn === 0){
        this.movimiento.efectivo_usd_mxn = null;
      }
      try {
        await this.$store.dispatch("movimientos/addIngreso", this.movimiento).then(() => {
          this.movimiento_ingreso = this.$store.getters["movimientos/addIngreso"];
          this.movimiento_ingreso = this.movimiento_ingreso.result.ingreso;
          //console.log(this.movimiento_ingreso);
        });
        this.$notify({
          type: "success",
          message: "Movimiento ingreso realizado satisfactoriamente.",
          duration: -1
        });
        //NUEVO POR MENSAJE TARJETA
        //this.showPayIngresoModal = false;
        this.finalizar = true;
        this.imprimir(this.movimiento_ingreso, 'ingreso');
        this.resetApiValidation();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
        this.resetApiValidation();
        this.setApiValidation(error.response.data.errors);
      }
    },

    async confirmarEgreso() {
      const confirmation = await swal.fire({
        title: `¿En verdad desea realizar el egreso de caja?`,
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-lg btn-default hover-apolo",
        cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
      });
      try {
        if (confirmation.value === true){
          try {
            if(this.movimiento.motivo_egreso != null){
              this.movimiento.motivo = this.movimiento.motivo_egreso;
            }
            this.movimiento.monto = this.calculateTotalPagoMovimiento;
            await this.$store.dispatch("movimientos/addEgreso", this.movimiento).then(() => {
              this.movimiento_egreso = this.$store.getters["movimientos/addEgreso"];
              this.movimiento_egreso = this.movimiento_egreso.result.egreso;
            });
            this.$notify({
              type: "success",
              message: "Movimiento egreso realizado satisfactoriamente.",
              duration: -1
            });
            this.imprimir(this.movimiento_egreso, 'egreso');
            } catch (error) {
              if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
              } else {
                this.$notify({
                    type: "danger",
                    message: "Oops, ha ocurrido un problema!",
                    duration: -1
                });
              }
            }
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Ocurrio un error.",
          duration: -1
        });
      }
    },

    async confirmarIngreso() {
      this.showPayIngresoModal = true;
    },

    registraMovimiento(){
      if(this.radio.status === null){
        this.movimiento.ingreso = false;
        this.movimiento.egreso = false;
      }
      if(this.radio.status == 'true'){
        this.movimiento.ingreso = true;
        this.movimiento.egreso = false;
      }
      if(this.radio.status == 'false'){
        this.movimiento.egreso = true;
        this.movimiento.ingreso = false;
      }
      if(this.movimiento.ingreso === false && this.movimiento.egreso === false){
        this.$notify({
          type: "danger",
          message: "Es necesario seleccionar ingreso o egreso",
          duration: -1
        });
        return;
      }
      if(this.movimiento.ingreso && this.movimiento.motivo_ingreso === null){
        this.$notify({
          type: "danger",
          message: "Es necesario seleccionar un motivo ingreso",
          duration: -1
        });
        return;
      }
      if(this.movimiento.egreso && this.movimiento.motivo_egreso === null){
        this.$notify({
          type: "danger",
          message: "Es necesario seleccionar un motivo egreso",
          duration: -1
        });
        return;
      }
      if(this.movimiento.cantidad === null){
        this.$notify({
          type: "danger",
          message: "Es necesario escribir una cantidad",
          duration: -1
        });
        return;
      }
      if(this.movimiento.detalles === null){
        this.$notify({
          type: "danger",
          message: "Es necesario escribir detalles",
          duration: -1
        });
        return;
      }
      this.movimiento.cantidad = this.movimiento.cantidad.replace('$', "");
      if(Number(this.movimiento.cantidad) < 0){
        this.$notify({
          type: "danger",
          message: "La cantidad debe ser mayor a 0",
          duration: -1
        });
        return;
      }
      if(this.movimiento.ingreso === true && this.movimiento.motivo_ingreso != null){
        this.confirmarIngreso();
      }
      if(this.movimiento.ingreso === false && this.movimiento.motivo_egreso != null){
        this.confirmarEgreso();
      }
    },

    async imprimir(movimiento, tipo) {
      //se obtienen datos de usuario autenticado
      let me = await this.$store.getters["profile/me"];
      // imagen a base64
      const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); 
          reader.onloadend = () => {
            const base64data = reader.result;   
            resolve(base64data);
          }
        });
      }
      let imagen = await getBase64FromUrl('/img/logoPrinter2.png');
      let printer = new Impresora;
      let tablaClass = Vue.extend(ImpresionMovimiento);
      let tablaInstancia = new tablaClass({
        propsData: { 
          movimiento: movimiento,
          tipo: tipo,
          user: me.attributes,
        }
      });
      let tabla_html = (tablaInstancia.$mount().$el.outerHTML).toString();
      let tabla = this.changeSimbol(tabla_html);
      printer.setAlign("center");
      printer.imagen(imagen);
      printer.setAlign("left");
      printer.html(tabla);
      printer.cut();
      printer.end().then(respuesta => {
        this.reload();
      });
    },

    reload(){
      this.$router.go(this.$router.currentRoute)
    },

    changeSimbol(s) {
      //var accent_map = {'á':'&aacute;', 'é':'&eacute;', 'è':'e', 'í':'&iacute;','ó':'&oacute;','ú':'&uacute;','Á':'&Aacute;', 'É':'&Eacute;', 'è':'e', 'Í':'&Iacute;','Ó':'&Oacute;','Ú':'&Uacute;', 'ñ':'&ntilde;;', 'Ñ':'&Ntilde;'};
      var accent_map = {'á':'a', 'é':'e', 'è':'e', 'í':'i','ó':'o','ú':'u','Á':'a', 'É':'e', 'è':'e', 'Í':'i','Ó':'o','Ú':'u', 'Ñ':'N', 'ñ':'n'};
      if (!s) { return ''; }
      var ret = '';
      for (var i = 0; i < s.length; i++) {
        ret += accent_map[s.charAt(i)] || s.charAt(i);
      }
      return ret;
    },
  },
};
</script>


  <style src="vue-multiselect/dist/vue-multiselect.min.css"/>
  <style lang="scss">
.argon-error {
  position: relative;
  bottom: 25px !important;
  color: #fb6340;
}
.table-container {
  //width: 100em;
  overflow-x: auto !important;
  white-space: nowrap !important;
}

.argon-error {
  position: relative;
  bottom: 25px !important;
  color: #fb6340;
}
.btn-outline-secondary {
  color: #eef0f2 !important;
  border-color: #eef0f2 !important;
}
.btn-outline-secondary:hover {
  color: #0068a0 !important;
  background-color: transparent !important;
  border-color: #0068a0 !important;
}
.btn-outline-success {
  color: #eef0f2 !important;
  border-color: #eef0f2 !important;
}

.btn-outline-success:hover {
  color: #0068a0 !important;
  background-color: transparent !important;
  border-color: #0068a0 !important;
}
</style>